import {useEffect, useState} from "react"
import {useAccount, useProvider} from "wagmi"
import {ethers} from "ethers"
import { WARRIOR_NFT, synthAbi, nftMap } from '@/utils/abi'
import { useNavigate } from 'react-router-dom';

export const usePrevent = () => {
  const { isConnected } = useAccount()
  const provider = useProvider()
  const navigate = useNavigate();

  useEffect(() => {
    if(!isConnected) {
      navigate("/mint", { replace: true });
    }
  }, [isConnected, provider]);
}